import React, { useEffect, useState } from "react";
import { GoogleMap, Polyline } from "@react-google-maps/api";
import VehicleMarker from "./customMarker";

const mapContainerStyle = {
  width: "100%",
  height: "550px",
};

const TripMapComponent = ({ locationsData }) => {
  const [coordinateArray, setCoordinateArray] = useState([]);
  const [openInfoWindow, setOpenInfoWindow] = useState(false);

  const handleMarkerClick = () => {
    setOpenInfoWindow(!openInfoWindow);
    // setOpenInfoStopWindow("");
  };

  const mapOption = {
    streetViewControl: false,
  };

  useEffect(() => {
    if (locationsData.length > 0) {
      let data = locationsData.map((d) => ({
        lat: d.coordinates[0],
        lng: d.coordinates[1],
      }));
      setCoordinateArray(data);
    }
  }, [locationsData]);

  const center =
    locationsData.length > 1
      ? {
          lat: locationsData[0]?.coordinates[0],
          lng: locationsData[1]?.coordinates[1],
        }
      : { lat: 22.9971613691464, lng: 72.49983287951699 };

  return (
    <div className="google-map-parent">
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={center}
        zoom={10}
        options={mapOption}
      >
        {coordinateArray.length > 1 && (
          <Polyline
            path={coordinateArray}
            options={{ strokeColor: "#2A7C76", strokeWeight: 5 }}
          />
        )}
        {coordinateArray.length > 1 && (
          <VehicleMarker
            currentVehicleData={locationsData[0]}
            currentPosition={coordinateArray[0]}
            locationData={locationsData}
            timeFilter={"today"}
            handleMarkerClick={handleMarkerClick}
            openInfoWindow={openInfoWindow}
          />
        )}
      </GoogleMap>
    </div>
  );
};

export default TripMapComponent;
